import { CRUDMutations } from '@/utils/store-utilities'

const defaultItem = (item) => ({
  ...item,
})

export const state = () => ({
  item: null,
  items: [],
})

export const mutations = {
  ...CRUDMutations(defaultItem),
}

export const getters = {}

export const actions = {
  createPalletType({ commit }, item) {
    return this.$axios.$post('admin/palletTypes/create', { ...item }).then((response) => {
      commit('add', { ...response.data })
      return response.data
    })
  },
  removePalletType({ commit }, item) {
    return this.$axios.$delete(`admin/palletTypes/${item.id}`).then((response) => {
      if (response.data) {
        commit('remove', item)
      }
    })
  },
  updatePalletType({ commit }, item) {
    return this.$axios.$put(`admin/palletTypes/${item.id}`, { ...item }).then((response) => {
      commit('update', { ...response.data })
      return response.data
    })
  },
  fetchPalletType({ commit }, id) {
    return this.$axios.$get(`admin/palletTypes/${id}`).then((response) => {
      return response.data
    })
  },
  fetchPalletTypes({ commit }, params = {}) {
    return this.$axios.$get('admin/palletTypes', { params }).then((response) => {
      commit('load', response.data)
      return response
    })
  },
  importCsv({ commit }, dataUrl) {
    return this.$axios.$post('admin/import/palletTypes', { file: dataUrl }).then((response) => response)
  },
  exportCsv() {
    return this.$axios.$get('admin/export/palletTypes', { responseType: 'blob' })
  },
}
